import Login from "../Pages/Login/Login";
import ResetPassword from "../Pages/Login/ResetPassword";
import { LocalUrlEnum } from "./Utils";
import Questionnaires from "../Pages/Questionnaire/Questionnaires";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import ReportsMainPage from "../Pages/Reports/ReportsMainPage";
import Settings from "../Pages/Settings";
import Logs from "../Pages/Logs/Logs";
import TrashedOrders from "../Pages/Orders/TrashedOrders";
import Categories from "../Pages/Categories/Categories";
import PaymentTypes from "../Pages/PaymentTypes/PaymentTypes";
import OrderStatus from "../Pages/OrderStatus/OrderStatus";
import EmailTemplates from "../Pages/Templates/EmailTemplates";
import DocumentTemplates from "../Pages/Templates/DocumentTemplates";
import QuestionnaireTemplate from "../Pages/Templates/QuestionnaireTemplate";
import QuestionnairesTemplates from "../Pages/Templates/QuestionnairesTemplates";
import Questionnaire from "../Pages/Questionnaire/Questionnaire";
import Device from "../Pages/Devices/Device";
import Devices from "../Pages/Devices/Devices";
import Order from "../Pages/Orders/Order";
import Orders from "../Pages/Orders/Orders";
import HomePage from "../Pages/Home/Home";
import Dashboard from "../Pages/Dashboard/Dashboard";
import CustomersOrders from "../Pages/Orders/CustomersOrders";
import DeviceRepairs from "../Pages/DeviceRepairs/DeviceRepairs";
import RepairOrders from "../Pages/RepairOrders/RepairOrders";
import RepairOrder from "../Pages/RepairOrders/RepairOrder";
import { Vocabulary } from "./Vocabulary";
import PageNotFound from "../Pages/Common/PageNotFound";
import AccountSettings from "../Pages/AccountSettings";
import CustomerOrder from "../Pages/Orders/CustomerOrder";
import UsersMainPage from "../Pages/Users/UsersMainPage";
import MultiOrder from "../Pages/MultiOrders/MultiOrder";

export const HttpStatusCode = {
  OK: 200,
  Created: 201,
  Accepted: 202,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  RequestTimeout: 408,
  InternalServerError: 500,
  NotImplemented: 501,
  UnprocessableEntity: 422,
};

export const breadCrumbsEnum = {
  users: "users",
  templates: "templates",
  questionnaires: "questionnaires",
  personalData: "personalData",
  emails: "emails",
  documents: "documents",
  reports: "reports",
  orderStatus: "orderStatus",
  trashedOrders: "trashedOrders",
  orders: "orders",
  logs: "logs",
  dashboard: "dashboard",
  devices: "devices",
  settings: "settings",
  categories: "categories",
  deviceRepairs: "deviceRepairs",
  repairOrders: "repairOrders",
  paymentTypes: "paymentTypes",
};

export const regexIBAN = "^RO[0-9]{2}[A-Z]{4}[A-z0-9]{16}$";
export const regexSeriesAndNumber = "^[A-Z]{2}[0-9]{6,7}$";

export const roles = {
  admin: "admin",
  serviceTechnician: "serviceTechnician",
  user: "user",
  customer: "customer",
};
const localStorageRole = localStorage.getItem("role");

export const routes = [
  {
    path: "",
    element: <Dashboard />,
    children: [
      { path: "/", element: getDefaultRouteElement() },
      {
        path: LocalUrlEnum.orders,
        element: <Orders />,
      },
      {
        path: `${LocalUrlEnum.orders}:id`,
        element: <Order />,
      },
      {
        path: LocalUrlEnum.devices,
        element: <Devices />,
      },
      {
        path: `${LocalUrlEnum.devices}:id`,
        element: <Device />,
      },
      {
        path: LocalUrlEnum.questionnaires,
        element: <Questionnaires />,
      },
      {
        path: `${LocalUrlEnum.questionnaires}:id`,
        element: <Questionnaire />,
      },
      {
        path: LocalUrlEnum.questionnairesTemplates,
        element: <QuestionnairesTemplates />,
      },
      {
        path: `${LocalUrlEnum.questionnairesTemplates}:id`,
        element: <QuestionnaireTemplate />,
      },
      {
        path: LocalUrlEnum.emailTemplates,
        element: <EmailTemplates />,
      },
      {
        path: LocalUrlEnum.documentTemplates,
        element: <DocumentTemplates />,
      },
      {
        path: LocalUrlEnum.users,
        element: <UsersMainPage />,
      },
      {
        path: LocalUrlEnum.orderStatus,
        element: <OrderStatus />,
      },
      {
        path: LocalUrlEnum.categories,
        element: <Categories />,
      },
      {
        path: LocalUrlEnum.paymentTypes,
        element: <PaymentTypes />,
      },
      {
        path: LocalUrlEnum.trashedOrders,
        element: <TrashedOrders />,
      },
      {
        path: LocalUrlEnum.logs,
        element: <Logs />,
      },
      {
        path: LocalUrlEnum.settings,
        element: <Settings />,
      },
      {
        path: LocalUrlEnum.accountSettings,
        element: <AccountSettings />,
      },
      {
        path: LocalUrlEnum.customerOrders,
        element: <CustomersOrders />,
      },
      {
        path: `${LocalUrlEnum.customerOrders}:id`,
        element: <CustomerOrder />,
      },
      {
        path: LocalUrlEnum.reports,
        element: <ReportsMainPage />,
      },
      {
        path: LocalUrlEnum.deviceRepairs,
        element: <DeviceRepairs />,
      },
      {
        path: LocalUrlEnum.repairOrders,
        element: <RepairOrders />,
      },
      {
        path: `${LocalUrlEnum.repairOrders}:id`,
        element: <RepairOrder />,
      },
      {
        path: `${LocalUrlEnum.multiOrders}:id`,
        element: <MultiOrder />,
      },
    ],
  },
  {
    path: LocalUrlEnum.login,
    element: <Login />,
  },
  {
    path: LocalUrlEnum.resetPassword,
    element: <ResetPassword />,
  },
  {
    path: "*",
    element: (
      <PageNotFound
        text={Vocabulary.youDoNotHavePermission}
        icon={<DoDisturbIcon style={{ fontSize: 65, color: "red" }} />}
      />
    ),
  },
];

function getDefaultRouteElement() {
  switch (localStorageRole) {
    case roles.admin:
    case roles.serviceTechnician:
    case roles.user:
      return <HomePage />;
    case roles.customer:
      return <CustomersOrders />;
    default:
      return <HomePage />;
  }
}

export const usersTypes = {
  employees: "employees",
  customers: "customers",
};
